import '@helpers/initAppConfig.js'
import { logger } from '@helpers/logger'
import ReactDOM from 'react-dom/client'
import App from '@app/App'
import '@helpers/appInfo/appInfo'

import { preloadAllLocales } from '@app/translations/translations'
import { getFeaturedTournamentPoolsSummary } from '@providers/services/featuredPoolsService'

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement)

root.render(<App />)

preloadAllLocales()
getFeaturedTournamentPoolsSummary()

logger.checkpoint("---  App Starting ---")
